// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__299AK","select":"Input_select__2iJ49","inputWrapper":"Input_inputWrapper__1MrCx","title":"Input_title__1L0h5","requiredStar":"Input_requiredStar__3gpIC"};